// appels views: how dates read on screen. Pure, tested in plain Node.
import { fromAlgiersIso } from "@core/utils";

/** `2026-11-15` as `15/11/2026` (day first, as the platform is written). Empty for nothing. */
export function formatCalendarDate(date: string | null | undefined): string {
  if (!date) return "";
  const match = /^(\d{4})-(\d{2})-(\d{2})/.exec(date);
  return match ? `${match[3]}/${match[2]}/${match[1]}` : "";
}

/** An instant as the Algeria date and time: `15/11/2026` and `09:00`. */
export function algiersParts(iso: string): { date: string; time: string } {
  const parts = fromAlgiersIso(iso);
  return { date: formatCalendarDate(parts.date), time: parts.time };
}
